export default __webpack_public_path__ + "static/media/jcb.56885cee.svg";